import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/img/animation.jpg";
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';
import navIcon4 from '../assets/images/github.svg';

export const Footer = () => {
  return (
    <>
      <style>{`
        .footer {
          padding: 20px 0;
          background-color: #222;
          color: #fff;
        }
        .footer .social-icon {
          margin-bottom: 10px;
        }
        .footer .social-icon a {
          margin: 0 10px;
        }
        .footer img {
          max-width: 100px;
        }
        .footer p {
          margin-top: 10px;
        }
      `}</style>
      <footer className="footer">
        <Container>
          <Row className="align-items-center">
            <MailchimpForm />
            <Col xs={12} sm={6}>
              <img src={logo} alt="Logo" />
            </Col>
            <Col xs={12} sm={6} className="text-center text-sm-end">
              <div className="social-icon">
                <a href="https://github.com/annuraagggiiit" target="_blank" rel="noopener noreferrer">
                  <img src={navIcon4} alt="Github" />
                </a>
                <a href="https://www.linkedin.com/in/anuragkhannaiiitm" target="_blank" rel="noopener noreferrer">
                  <img src={navIcon1} alt="Linkedin" />
                </a>
               
                <a href="https://www.instagram.com/annuraaggg" target="_blank" rel="noopener noreferrer">
                  <img src={navIcon3} alt="Instagram" />
                </a>
              </div>
              <p>Designed And Developed By Anurag Khanna. Copyright 2024. All Rights Reserved</p>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
};
